import { jsonConstants } from '@thoughtspot/json-constants';
import _ from 'lodash';
import GeoConfig from '../geomap/base/geo-config';
export const getGeoConfig = (col) => {
    const geoConfigKey = _.get(col, jsonConstants.GEO_CONFIG_KEY);
    if (!_.isEmpty(geoConfigKey)) {
        return new GeoConfig(geoConfigKey);
    }
    return null;
};
//# sourceMappingURL=geo-column-utils.js.map